<script lang="ts" setup></script>

<template>
  <div class="flex flex-col gap-4 p-4 shadow-inner">
    <slot />
  </div>
</template>

<style scoped>
:deep(a) {
  @apply border-b-2 border-green-300 pb-0;
  border-image: linear-gradient(to right, #6ee7b7, #fcd34d) 1;
}

:deep(a:has(img)) {
  @apply border-b-0;
}
</style>
